app.service("SiteRangeService", ['$rootScope', function ($rootScope) {

    const service = this;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const SiteRangeModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Site Range",
        id: "site_range",
        navigation_pointer: "site_range_id"
    });

    this.factory = new modelConstructor.RouteFactory({
        birth: function (values) {
            return new SiteRangeModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const browseID = variationIDs.browse_id;
        const solutionID = variationIDs.solution_id;
        const baseComponentID = variationIDs.base_component_id;
        const parentCategoryGroupID = variationIDs.parent_category_group_id;
        const parentCategoryID = variationIDs.parent_category_id;
        const alphaCategoryID = variationIDs.alpha_category_id;
        const productID = variationIDs.product_id;

        let choiceOrder = [];
        let nextModelID = "colour_route";

        if (solutionID === "kitchen_inrail") {
            choiceOrder = ['valore', 'firbeck', 'ora', 'bella', 'zurfiz'];
        } else if (solutionID === "bedroom_flat_pack") {
            choiceOrder = ['valore', 'ora', 'bella', 'zurfiz'];
        } else if (solutionID) {
            choiceOrder = ['valore', 'firbeck', 'ora', 'jayline', 'wilton', 'bella', 'zurfiz', 'thornbury', 'hadley'];
        } else {
            choiceOrder = service.getSiteRangeIDs();
        }

        const cacheValidSiteRangeIDs = $rootScope.service.cache_local_server.getValidSiteRangeIDs(baseComponentID, parentCategoryGroupID, parentCategoryID, alphaCategoryID, productID);
        if (cacheValidSiteRangeIDs) {
            for (let i = 0; i < choiceOrder.length; i++) {
                if (!cacheValidSiteRangeIDs.includes(choiceOrder[i])) {
                    choiceOrder.splice(i, 1);
                    i--;
                }
            }
        }

        const cacheChoices = getCacheChoices();
        const choices = {};

        for (let i = 0; i < choiceOrder.length; i++) {
            const choiceID = choiceOrder[i];
            const cacheChoice = cacheChoices[choiceID];
            if (!cacheChoice || cacheChoice.disabled) {
                choiceOrder.splice(i, 1);
                i--;
                continue;
            }
            const choice = new RouteChoice(JSON.parse(JSON.stringify(cacheChoice)));

            choice.state_ids.request_range_id = choice.request_range_id;
            if (choice.request_range_id !== "bella") {
                choice.state_ids.style_id = choiceID;
            }
            choice.is_timber = !!choice.is_timber;
            choice.disabled = !!choice.disabled;
            choice.disabled_temporarily = !!choice.disabled_temporarily;

            choice.colour_count = choice.colour_count ? choice.colour_count : 0;
            choice.style_count = choice.style_count ? choice.style_count : 0;

            choice.actual_colour_count = choice.actual_colour_count ? choice.actual_colour_count : 0;
            choice.actual_style_count = choice.actual_style_count ? choice.actual_style_count : 0;

            choice.m2m_expected = !!choice.m2m_expected;
            choice.m2m = choice.m2m_expected ? !!choice.m2m : false;

            choice.state_values.site_range_name = choice.name;
            choice.state_values.site_range_m2m = !!choice.m2m;
            choice.state_values.site_range_m2m_expected = !!choice.m2m_expected;
            choice.state_values.site_range_is_timber = !!choice.is_timber;

            choices[choiceID] = choice;
        }


        if (browseID === "component") {
            const component_Object = $rootScope.service.cache_local_server.getAnySiteRangeComponentObject(variationIDs.base_component_id, variationIDs.parent_category_group_id, variationIDs.parent_category_id, variationIDs.alpha_category_id);
            if (component_Object && !component_Object.requires_colour && !component_Object.requires_style) {
                const preferredSiteRangeIDs = component_Object.preferred_site_range_ids;
                if (preferredSiteRangeIDs && preferredSiteRangeIDs.length) {
                    let valid = true;
                    for (let i = 0; i < preferredSiteRangeIDs.length; i++) {
                        if (!choiceOrder.includes(preferredSiteRangeIDs[i])) {
                            valid = false;
                            break;
                        }
                    }
                    if (valid) {
                        for (let i = 0; i < choiceOrder.length; i++) {
                            if (!preferredSiteRangeIDs.includes(choiceOrder[i])) {
                                choiceOrder.splice(i, 1);
                                i--;
                            }
                        }
                    }
                }
            }
        }

        if (browseID === "site_range") {

            choices.hettich = new RouteChoice({
                name: "Hettich",
                img_src: "/img/browse/property/site-range/site-range-hettich.png",
                next_model_id: "tab",
                state_ids: {
                    component_id: "hettich"
                }
            });
            const stockChoices = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", ["cabinet_interior"]);

            let storageChoice = null;
            for (let i = 0; i < stockChoices.length; i++) {
                const stockChoice = stockChoices[i];
                switch (stockChoice.id) {
                    case "cabinet_interior":
                        storageChoice = stockChoices[i]
                        storageChoice.next_model_id = "collection_product";
                        storageChoice.public_id = "storage";
                        storageChoice.name = "Storage";
                        choices.storage = storageChoice;
                        break;
                    default:
                        break;
                }
            }
            choiceOrder = choiceOrder.concat(['hettich', 'storage']);
            nextModelID = "method_input";
        }

        model.choices = choices;
        model.choice_order = choiceOrder;
        model.next_model_id = nextModelID;
    }

    function getCacheChoices() {
        return $rootScope.model.cache_local_server.site_range.choices;
    }

    function getCacheChoice(siteRangeID) {
        const cacheChoices = getCacheChoices();
        const cacheChoice = cacheChoices[siteRangeID];
        return cacheChoice ? cacheChoice : null;
    }


    this.getSiteRangeIDs = function (prontoOnly, excludePronto) {
        const siteRangeIDs = $rootScope.model.cache_local_server.site_range.choice_order.slice();
        if (prontoOnly || excludePronto) {
            const cacheChoices = getCacheChoices();
            for (let i = 0; i < siteRangeIDs.length; i++) {
                const cacheChoice = cacheChoices[siteRangeIDs[i]];
                const isPronto = cacheChoice.request_range_id === "pronto";
                const requirePronto = !!prontoOnly;
                if (isPronto !== requirePronto) {
                    siteRangeIDs.splice(i, 1);
                    i--;
                }
            }
        }
        return siteRangeIDs;
    }

    this.getRequestRangeID = function (siteRangeID) {
        const cacheChoice = getCacheChoice(siteRangeID);
        return cacheChoice ? cacheChoice.request_range_id : null;
    }


}]);